import { LazyAction, LazyImport, LazyModule, preloadScriptChunk } from 'owa-bundling';
import { FileSelectionFilter, FilePickerAction, SelectedFilesSource, filePickerStore, lazyPreloadFilePicker, SizeLimitInKbToSuggestSharing, } from 'owa-filepicker-store';
/* This package is supposed to encapsulate all the attachment logic around owa-filepicker */
preloadScriptChunk('AttachmentFilePicker');
var lazyModule = new LazyModule(function () {
    return System.import(/* webpackChunkName: "AttachmentFilePicker" */ './lazyIndex');
});
// Delay loaded actions
export var lazyAttachmentFilePicker = new LazyAction(lazyModule, function (m) { return m.attachmentFilePicker; });
export var lazyAttachmentActionsPanel = new LazyAction(lazyModule, function (m) { return m.attachmentActionsPanel; });
// Delay loaded imports
export var lazyInitializeAttachmentFilePicker = lazyPreloadFilePicker;
export var lazyGetUserPreferredFilePickerActions = new LazyImport(lazyModule, function (m) { return m.getUserPreferredFilePickerActions; });
export { filePickerStore as attachmentFilePickerStore };
export { AttachmentDataProviderType, FilePickerAction, FileSelectionFilter, LazyImport, SelectedFilesSource, SizeLimitInKbToSuggestSharing, };
//# sourceMappingURL=index.js.map